import { useUser } from '~/@biz_account/useUser/useUser'
import { BackButton } from '~/@pages_investing/project-detail/project-detail_ui/back-button/BackButton'
import { IdentityVerificationConfirmation } from './IdentityConfirmation'

function IdentityConfirmationContent() {
  const { reloadUser } = useUser()
  return (
    <>
      <div className="flex justify-start">
        <BackButton route="/">Späť</BackButton>
      </div>
      <IdentityVerificationConfirmation onVeriffConfirmed={reloadUser} />
    </>
  )
}

export { IdentityConfirmationContent }
